module.exports = __webpack_public_path__ + "static/media/card-header0.df4c19bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/headers/card-header0.jpg
// module id = 1128
// module chunks = 0